import { useState, useEffect } from "react";
import { FloatingContainer } from "ui/floating/FloatingContainer";
import { FloatingToggleButton } from "ui/floating/FloatingToggleButton";
import { FloatingPanel } from "ui/floating/FloatingPanel";
import { ContactForm } from "components/contactForm";



export const FloatingContactForm = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = (e: KeyboardEvent) =>
      e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, []);

  useEffect(() => {
    const saved = localStorage.getItem("contact_open");
    if (saved) setOpen(false);
  }, []);

  useEffect(() => {
    localStorage.setItem("contact_open", String(open));
  }, [open]);

  return (
    <FloatingContainer>
      {!open ? (
        <FloatingToggleButton onClick={() => setOpen(true)}>
          💬
        </FloatingToggleButton>
      ) : (
        <FloatingToggleButton onClick={() => setOpen(false)}>
          ✖
        </FloatingToggleButton>
      )}

      <FloatingPanel $open={open}>
        <ContactForm onClose={() => setOpen(false)} />
      </FloatingPanel>
    </FloatingContainer>
  );
};
